







import D3VerticalLine from './d3_vertical_line'
import D3Dot from './d3_dot'

export default {
  props: {
    width: Number,
    height: Number,
    points: Array,
    i: Number
  },

  computed: {
    x(): number {
      return this.i / (this.n - 1) * this.width
    },
    n(): number {
      return this.points.length
    }
  },

  components: {
    D3VerticalLine,
    D3Dot
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/evaluation_graph/hover_indicator.vue